import { render, staticRenderFns } from "./OrderPartnerAttachments.vue?vue&type=template&id=0f8909e8&scoped=true&"
import script from "./OrderPartnerAttachments.vue?vue&type=script&lang=js&"
export * from "./OrderPartnerAttachments.vue?vue&type=script&lang=js&"
import style0 from "./OrderPartnerAttachments.vue?vue&type=style&index=0&id=0f8909e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8909e8",
  null
  
)

export default component.exports